import React, { useEffect } from 'react'
import { Provider } from 'react-redux'

import { createFirestoreInstance } from 'redux-firestore'
import { ReactReduxFirebaseProvider } from 'react-redux-firebase'
import { loadFontIcons } from './components/FontIcon'

import firebase from './utils/firebase'
import store from './utils/store'

import Router from './routes'
import { authenticate } from './modules/app.module'

const App = () => {
  useEffect(() => {
    store.dispatch(authenticate())
    loadFontIcons()
  }, [])

  // react-redux-firebase config
  const rrfConfig = {
    userProfile: 'users',
    useFirestoreForProfile: true, // Firestore for Profile instead of Realtime DB
  }

  const rrfProps = {
    firebase,
    config: rrfConfig,
    dispatch: store.dispatch,
    createFirestoreInstance, // <- needed if using firestore
  }

  // render() {
  return (
    <Provider store={store}>
      <ReactReduxFirebaseProvider {...rrfProps}>
        <Router />
      </ReactReduxFirebaseProvider>
    </Provider>
  )
  // }
}

export default App
